"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const cosmos_1 = require("components/cosmos");
const dropdown_1 = require("components/cosmos/v2/dropdown");
const translationContext_1 = require("configs/translationContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const stores_1 = require("modules/content/dripping/stores");
const mapStateToProps = (stores) => ({
    isActionInProgress: stores.BulkDrippingStore.isActionInProgress
});
const BulkScheduleButton = ({ isActionInProgress, isDisabled }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const handleNewClick = () => {
        stores_1.BulkDrippingStore.startNewAction();
    };
    const handleDeleteClick = () => {
        stores_1.BulkDrippingStore.startDeleteAction();
    };
    return ((0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown, { children: [(0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.Slot, { children: ({ slot, className }) => ((0, jsx_runtime_1.jsxs)(cosmos_1.Button, { variation: "tertiary", slot: slot, className: className, disabled: isDisabled || isActionInProgress, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'calendar-day'], className: "_mr-2" }), t('general.schedule')] })) }), (0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown.Menu, { children: [(0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown.MenuItem, { className: "_p-4", role: "button", onClick: handleNewClick, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'plus'], className: "_mr-2" }), t('dripping_2.actions.new')] }), (0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown.MenuItem, { className: "_p-4 _text-red", role: "button", onClick: handleDeleteClick, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'trash'], className: "_mr-2" }), t('dripping_2.actions.remove')] })] })] }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)(mapStateToProps))(BulkScheduleButton);
